import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CuestionariosSaludComponent } from './components/cuestionarios-salud.component';
import { CuestionariosSaludRoutingModule } from './cuestionarios-salud.routing.module';

@NgModule({
  declarations: [CuestionariosSaludComponent],
  imports: [CommonModule, CuestionariosSaludRoutingModule],
  providers: [],
  exports: [CuestionariosSaludComponent]
})
export class CuestionariosSaludModule {}
